import React from 'react';
import Box from '@material-ui/core/Box';
import Tooltip from '@material-ui/core/Tooltip';
import InfoIcon from '@material-ui/icons/Info';

import { ROLE_DESCRIPTIONS } from '../../../../_configuration';

export const clampedLabelStyle: React.CSSProperties = {
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  overflowWrap: 'break-word',
  wordBreak: 'normal',
  minWidth: 0,
};

export const HeaderWithTooltip = ({ label, role }: { label: string; role?: string }): React.ReactElement => {
  const labelEl = <span title={label} style={clampedLabelStyle}>{label}</span>;

  if (!role || !ROLE_DESCRIPTIONS[role]) return labelEl;

  return (
    <Box display="flex" alignItems="center" justifyContent="center" style={{ gap: '0.5rem', minWidth: 0 }}>
      {labelEl}
      <Tooltip title={ROLE_DESCRIPTIONS[role]} arrow>
        <InfoIcon style={{ fontSize: 16, color: '#ccc', cursor: 'help', flexShrink: 0 }} />
      </Tooltip>
    </Box>
  );
};
